import "@hotwired/turbo-rails"
import "./controllers";
import $ from "jquery";
window.$ = window.jQuery = $;

// Custom stream action used to break out of a Turbo Frame with a full-page navigation,
// e.g. when the session has expired and the user needs to be redirected to the login screen.
window.Turbo.StreamActions.redirect = function () {
   window.location.href = this.target
}
